import { makeStyles } from "@material-ui/core/styles";
import { h1, h5Regular } from "../../shared/typography";
import { withOpacity } from "../../shared/mixins";

export const usePrivacyStyles = makeStyles((theme) => ({
  root: {
    maxWidth: "78%",
    margin: "0 auto",
    padding: theme.spacing(4),
    paddingTop: 144,
  },

  mainHeader: {
    ...h1,
    textAlign: "center",
    marginBottom: theme.spacing(1),
  },

  subMainHeader: {
    ...h5Regular,
    ...withOpacity(0.64),
    textAlign: "center",
    marginBottom: theme.spacing(4),
  },

  content: {
    ...h5Regular,
    ...withOpacity(0.64),
    marginBottom: theme.spacing(1.5),
  },

  list: {
    paddingLeft: theme.spacing(3),
    marginBottom: theme.spacing(2),
    ...h5Regular,
    "& li": {
      "& a": {
        color: "#80BB34",
        ...withOpacity(1),
      },
    },
  },

  rtl: {
    direction: "rtl",
    textAlign: "right",
  },
}));
